import UpdateItemTransfer from "../../../../components/@documents/item_transfers/UpdateItemTransfer";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemTransferUpdatePage() {

    return (
        <UpdateItemTransfer 
            routeType={routeTypes.workstation}
        />
    )
}